export class OriginDestinationLocationType {
}
OriginDestinationLocationType.Unknown = 0;
OriginDestinationLocationType.Residential = 1;
OriginDestinationLocationType.PointOfInterest = 2;
